<template>
  <el-upload
    ref="elUpload"
    action=""
    :limit="1"
    style="display: none;"
    :accept="accept"
    :show-file-list="false"
    :http-request="handleHttpRequest">
    <i ref="upload"></i>
  </el-upload>
</template>

<script>
export default {
  name: 'UploadNew',
  props: {
    value: { type: Boolean, default: false },
    callback: Function,
    action: {
      type: String,
      default: 'account/uploadfile'
    },
    accept: {
      type: String,
      default: '.pdf,.doc,.docx'
    }
  },
  data () {
    return {
      options: {},
      customHttp: null
    }
  },
  computed: {
    loading: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleHttpRequest (file) {
      const formData = new FormData()
      formData.append('file', file.file)
      for (const key in this.options) {
        formData.append(key, this.options[key])
      }
      if (this.customHttp) {
        this.customHttp(formData)
        this.$refs.elUpload.clearFiles()
        this.customHttp = null
        return
      }
      this.loading = true
      this.$store.dispatch(this.action, {
        payload: formData,
        success: (res) => {
          this.loading = false
          // this.$message.success('上传成功')
          this.$refs.elUpload.clearFiles()
          this.callback && this.callback(this.options, res.data.viewUrl + res.data.filepath, res.data)
        },
        fail: () => {
          this.$refs.elUpload.clearFiles()
          this.loading = false
        }
      })
    },
    upload (row = {}, customHttp = null) {
      this.customHttp = customHttp
      this.options = row
      this.$refs.upload.click()
    }
  }
}
</script>

<style>

</style>
